import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHeader from './components/ContactHeader';
import ContactInfo from './components/ContactInfo';

const ContactPage = () => {
  return (
    <>
      <title>İletişim | İstanbul Dental Kongresi 2026</title>
      <meta name="description" content="İstanbul Dental Kongresi 2026 iletişim bilgileri. Genç Diş Hekimliği Derneği ile irtibata geçin. Sorularınız ve kayıt hakkında bilgi almak için iletişim formumuzu kullanın." />
      <meta name="keywords" content="istanbul dental kongresi iletişim, dental kongre 2026 iletişim, genç diş hekimliği derneği iletişim" />
      <link rel="canonical" href="https://ankaradentalkongresi.com/iletisim" />
      <meta property="og:title" content="İletişim | İstanbul Dental Kongresi 2026" />
      <meta property="og:description" content="İstanbul Dental Kongresi 2026 iletişim bilgileri. Sorularınız için bize ulaşın." />
      <meta property="og:url" content="https://ankaradentalkongresi.com/iletisim" />
      <div className="min-h-screen bg-white">
        <Navbar />
        <ContactHeader />
        <ContactInfo />
        <Footer />
      </div>
    </>
  );
};

export default ContactPage;
